<template>

<b-nav tabs>
    <b-nav-item :to="route" v-for="route in routerLinks" :key="route.name"
                active-class="active">
        {{ pages[route.name].title }}
        <template v-if="editFlag[route.name] === true">*</template>
    </b-nav-item>
</b-nav>

</template>

<script>

import pages from '@/routing/pages.js';

export default {
    data() {
        return {
            editFlag: {},
            pages
        }
    },

    props: ['routes', 'job'],

    computed: {
        routerLinks() {
            const routerLinks = this.routes.map((routeName) => {
                return {
                    name: routeName,
                    params: {
                        job_id: this.job.id
                    }
                }
            });

            return routerLinks;
        }
    },



    created() {
        this.clearStatuses();
        this.job.on('saved', this.clearStatuses);
        this.$eventBus.$on('section-changed', this.setEditStatus);
        this.$eventBus.$on('job-saved', this.clearStatuses);
    },

    methods: {
        setEditStatus(routePath) {
            this.$set(this.editFlag, routePath, true);
        },

        unsetEditStatus(routePath) {
            this.$set(this.editFlag, routePath, false);
        },

        clearStatuses() {
            Object.keys(this.editFlag).forEach((key) => {
                this.$set(this.editFlag, key, false);
            });
        }
    },

    beforeDestroy() {
        this.job.off('saved', this.clearStatuses);
        this.$eventBus.$off('section-changed', this.setEditStatus);
        this.$eventBus.$off('job-saved', this.clearStatuses);
    }
}

</script>
